import { useState } from "react";
import toast from "react-hot-toast";

import {
  setReviewSessionState,
  startReviewSession,
  getApiErrorMessage,
} from "../../../../services/case-manager/readingReviewSession";
import continueIllustration from "../../../../assets/images/reading-review/continue-session.png";
import styles from "./ReadingReviewSession.module.css";

// SCRUM-850: "Continue paused Session?" - Continue reopens the paused session
// exactly where it was left (API #5 continue); Start New abandons it and
// starts a fresh one for the same case manager (API #3). Readings already
// saved in the paused session are kept either way.
const ContinuePausedSession = ({ accId, session, caseManager, locationIds, onEnterSession, onBack }) => {
  const [busy, setBusy] = useState(null);

  const run = async (kind, request) => {
    setBusy(kind);
    try {
      onEnterSession(await request());
    } catch (error) {
      toast.error(getApiErrorMessage(error));
      // 409 session_locked / session_closed: someone else has it now, or it
      // ended - go back and pick again.
      if (error?.response?.status === 409) onBack();
    } finally {
      setBusy(null);
    }
  };

  const locationNames = (session.locations || []).map((loc) => loc.name).join(", ");
  const startLocationIds = locationIds?.length
    ? locationIds
    : (session.locations || []).map((loc) => loc.id);

  return (
    <div className={styles.centered}>
      <img src={continueIllustration} alt="" className={styles.illustration} />
      <h3 className={styles.heading}>Continue paused Session?</h3>
      <p className={styles.subheading} style={{ marginBottom: 10 }}>
        do you want to continue the previous workflow or start new?
      </p>
      <p className={styles.promptDetails}>
        {caseManager?.name || session.case_manager?.name}
        {locationNames ? ` · ${locationNames}` : ""}
        <br />
        {session.completed_patients} of {session.total_patients} patients done ({session.progress_percent}%)
        {session.paused_by?.name ? ` · Paused by ${session.paused_by.name}` : ""}
      </p>

      <div className={styles.buttonRow}>
        <button
          type="button"
          className={styles.secondaryBtn}
          disabled={!!busy}
          onClick={() =>
            run("new", () =>
              startReviewSession(accId, {
                caseManagerId: caseManager?.id ?? session.case_manager?.id,
                locationIds: startLocationIds,
              })
            )
          }
        >
          {busy === "new" ? "Starting…" : "Start New"}
        </button>
        <button
          type="button"
          className={styles.primaryBtn}
          disabled={!!busy}
          onClick={() => run("continue", () => setReviewSessionState(accId, session.id, "continue"))}
        >
          {busy === "continue" ? "Continuing…" : "Continue"}
        </button>
      </div>
      <button
        type="button"
        className={styles.secondaryBtn}
        style={{ marginTop: 14, border: "none", textDecoration: "underline", minWidth: 0 }}
        onClick={onBack}
        disabled={!!busy}
      >
        Back to Selection
      </button>
    </div>
  );
};

export default ContinuePausedSession;
